import React from "react";

require ('./googlemaps.scss')

export default ({mapId}) => (
    <iframe src={"https://www.google.com/maps/d/u/0/embed?mid=" + mapId} frameborder="0" style={{border:0}} allowfullscreen />
)